export interface FluidItemSize { width: number; height?: number; maxWidthPercent?: number }
export const normalizeFluidSize = (value: unknown): FluidItemSize | undefined => {
  if (!value || typeof value !== 'object') return undefined;
  const { width, height, maxWidthPercent } = value as Partial<FluidItemSize>;
  if (typeof width !== 'number' || !Number.isFinite(width)) return undefined;
  return { ...(typeof maxWidthPercent === 'number' && Number.isFinite(maxWidthPercent) ? { maxWidthPercent: Math.max(1, Math.min(100, maxWidthPercent)) } : {}), width: Math.max(24, Math.min(2400, width)), ...(typeof height === 'number' && Number.isFinite(height) ? { height: Math.max(24, Math.min(2400, height)) } : {}) };
};

/** Keep the requested width on the current canvas; distribute remaining space among siblings. */
export const resizeFluidItems = (widths: readonly number[], index: number, width: number, available: number): number[] => {
  const target = Math.max(24, Math.min(Math.max(24, available), width));
  const others = widths.reduce((sum, item, position) => sum + (position === index ? 0 : item), 0);
  return widths.map((item, position) => position === index ? target : Math.max(24, (available - target) * item / Math.max(1, others)));
};

export const fluidItemStyles = (size: FluidItemSize): string[] => [
  `--vp-fluid-weight: ${size.width};`,
  `--vp-fluid-max: ${size.maxWidthPercent ?? 100}%;`,
  `--vp-fluid-min: ${Math.min(320, size.width)}px;`,
  ...(size.height ? [`--vp-fluid-ratio: ${size.width / size.height};`] : []),
];

